import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TrybeService } from 'src/app/services/trybe.service';

@Component({
    selector: 'app-treatment-timeslot-selection',
    templateUrl: './treatment-timeslot-selection.component.html',
    styleUrls: ['./treatment-timeslot-selection.component.css']
})
export class TreatmentTimeslotSelectionComponent implements OnInit {
    @Input() basketItem;
    @Input() guests = [];
    @Input() offering;
    @Input() dateFrom = '';

    @Output() complete = new EventEmitter();

    avLoaded = false;
    timeslots = [];
    guestIdx = 0;

    constructor(
        private tryBeService: TrybeService,
    ) { }

    ngOnInit() {
        this.getTimeSlots();
    }

    getTimeSlots() {
        this.avLoaded = false;
        if (this.offering.type === 'package') {
            // this.tryBeService.getPackageTimeSlots(this.offering.type, this.offering.id, this.dateFrom).subscribe(data => {
            //     data.data.data.forEach((e, idx) => {
            //         this.selectGuest(this.guestIdx)
            //     });
            //     this.avLoaded = true;
            // })

        } else {

            this.tryBeService.getTimeSlots(this.offering.type, this.offering.id, this.dateFrom).subscribe(data => {
                this.timeslots = data.data.data;
                this.selectGuest(this.guestIdx)
                data.data.data.forEach((e, idx) => {
                });
                this.avLoaded = true;
            })
        }
    }
    selectGuest(idx) {
        this.guests[idx].active = true;
        this.guests[idx].appointment = undefined;
    }

    selectSlot(slot) {
        if (!this.basketItem.spa) {
            this.basketItem.spa = {}
        }
        this.guests[this.guestIdx].appointment = slot.appointments[0];
        this.guests[this.guestIdx].active = false;

        this.addToTrybeBasket(slot.appointments[0])

    }

    // addToTrybeBasket(appointment) {
    //     this.tryBeService.basketAddItem(this.basketItem.spa.trybeBasket.id, this.offering, appointment, this.guests[this.guestIdx]).subscribe(data => {
    //         this.basketItem.spa.trybeBasket = data.data.data;
    //         const nextIdx = this.guestIdx + 1;

    //         if (nextIdx < this.guests.length) {
    //             this.guestIdx = nextIdx;
    //             this.getTimeSlots()
    //         } else {

    //             // this.gaService.addSpaProduct(this.offering, appointment)
    //             this.confirm()
    //         }

    //     })
    // }

    addToTrybeBasket(appointment) {

        if (this.offering.min_guests > 1) {
            console.log(this.guests)
            console.log(this.guests[0])
            this.tryBeService.basketAddItem(this.basketItem.spa.trybeBasket.id, this.offering, appointment, this.guests).subscribe(data => {
                this.basketItem.spa.trybeBasket = data.data.data;

                this.confirm()
            })


        } else {
            this.tryBeService.basketAddItem(this.basketItem.spa.trybeBasket.id, this.offering, appointment, this.guests[this.guestIdx]).subscribe(data => {
                this.basketItem.spa.trybeBasket = data.data.data;

                const nextIdx = this.guestIdx + 1;

                if (nextIdx < this.guests.length) {
                    this.guestIdx = nextIdx;
                    this.getTimeSlots()
                } else {

                    this.confirm()
                }

            })

        }

    }


    confirm() {
        this.complete.emit({ action: true, guests: this.guests, basketItem: this.basketItem });
    }
    close() {
        this.complete.emit({ action: false });
    }

}
